export default "__VITE_ASSET__QeRHm1st__"